<header class="app-header">

  <div class="logo">
    <img src="assets/Sky_Logo.png" alt="Sky Logo" />
  </div>

  <div class="supplier-search-logo">
    <img src="assets/SupplierSearch.png" alt="Sky Logo" />
  </div>

  <div class="user-section">
    <div class="user-icon">
      {{ userInitials }}
    </div>
    <span class="username">{{ displayName }}</span>
    <a (click)="logout()" class="logout-link">Sign Out</a>
  </div>

</header>
